import React from 'react'
import { StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Text } from '@components'
import { Theme } from '@theme'

interface FormSectionProps {
  title: string
  children: React.ReactNode
  testID?: string
  /** Draw above the following sections (a dropdown overflows this card). */
  raised?: boolean
}

/** Titled card grouping the related fields of the event form. */
export function FormSection({ title, children, testID, raised = false }: FormSectionProps) {
  const theme = useTheme()
  const styles = getStyles(theme)
  return (
    <View style={[styles.card, raised && styles.raised]} testID={testID}>
      <Text type="subtitleBold" color={theme.colors.black}>
        {title}
      </Text>
      {children}
    </View>
  )
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    card: {
      width: '100%',
      maxWidth: 760,
      gap: theme.spacing.lg,
      padding: theme.spacing.xxl,
      borderRadius: theme.border.jumbo,
      borderWidth: 1,
      borderColor: theme.colors.grey,
      backgroundColor: theme.colors.white,
    },
    raised: { position: 'relative', zIndex: 20 },
  })
